import ProfileActionPanelSwitch from "./ProfileActionPanel";

export default ProfileActionPanelSwitch;
